import authentication from './authentication'
import company from './company'
import integrations from './integrations'
import users from './users'

export default {
  company,
  integrations,
  users,
  authentication
}
